import * as React from "react"
const SvgComponent = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={11}
    height={11}
    fill="none"
    {...props}
  >
    <path stroke={props.stroke || "#9D968D"} d="M3 1h7v7M1 10l8.5-8.5" />
  </svg>
)
export default SvgComponent
